"use client"

import { useConfigParams } from "@/hooks/use-config-params"
import {
  ThemeProvider as NextThemesProvider,
  ThemeProviderProps,
} from "next-themes"

export function ThemeProvider({
  children,
  APP_VENDOR = "sisal",
}: ThemeProviderProps & { APP_VENDOR?: string }) {
  const { channel } = useConfigParams()
  return (
    <NextThemesProvider
      attribute="class"
      forcedTheme={`${APP_VENDOR}-theme-${channel}`}
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  )
}
